import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1812f488&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1812f488&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812f488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1812f488')) {
      api.createRecord('1812f488', component.options)
    } else {
      api.reload('1812f488', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1812f488&scoped=true", function () {
      api.rerender('1812f488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overseasInventory/rate/index.vue"
export default component.exports